import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { downloadBuffer } from 'utils/download';

export const projectPDFMutations = getMutations({
  downloadPDFByCode: {
    action: async ({ code, name }: { code: string; name?: string }): Promise<void> => {
      const data = await executeApiCall<Buffer>({
        path: '/projects/pdf',

        method: 'get',

        auth: false,

        payload: {
          code,
        },

        responseType: 'arraybuffer',
      });

      downloadBuffer(`${name || 'offerwise-project'}.pdf`, data);
    },

    messages: {
      error: {
        title: 'Error generating document',
        description: 'If the error persists, contact support',
      },
    },
  },

  downloadPDF: {
    action: async ({
      projectId,
      type,
      name,
    }: {
      projectId: string;
      name?: string;
      type: 'DIRECT_COSTS' | 'WITH_SERVICES_BREAKDOWN';
    }): Promise<void> => {
      const data = await executeApiCall<Buffer>({
        path: '/projects/pdf',

        payload: {
          projectId,
          type,
        },

        responseType: 'arraybuffer',
      });

      downloadBuffer(`${name || 'offerwise-project'}.pdf`, data);
    },

    messages: {
      error: (t) => ({
        title: t('pdf-download-error'),
        type: 'error',
      }),
    },
  },
});
